import * as R from 'ramda';
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = ({ normalizeCurrency }) => normalizeCurrency;

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.sortBy(R.prop('index'), R.values(itemList)),
);

const makeSelectPagination = () => createSelector(
  store,
  ({ pagination }) => pagination,
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectActiveTab = () => createSelector(
  store,
  ({ activeTab }) => activeTab,
);

export {
  makeSelectItemList,
  makeSelectActiveTab,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectUsedReport,
  makeSelectListLoading,
};
